import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CardWrapper from "../../CardWrapper";
import Card from "../../Card";
import { getOMIMData } from "../../../../state/selectors/Omim.selectors";
import { getPathogenicityColorByAllNames } from "../../../../common/helpers/Constant";

const OMIMCard = ({ card, data }) => {
  const isDisabled = !Object.keys(data || {}).length;

  const calcBackgroundColor = () => {
    let color = getPathogenicityColorByAllNames("P");
    if (data && data[0]?.items) {
      const { items } = data[0] || [];
      if (items.length === 0) {
        color = getPathogenicityColorByAllNames("B");
      }
    }
    return color;
  };

  return (
    <CardWrapper
      {...card}
      card={card}
      isDisabled={isDisabled}
      wizardId="omim"
      color={calcBackgroundColor()}
    >
      <>
        {data && data[0]?.items && (
          <div data-testid="phenotypes">
            Related Phenotypes:{" "}
            <b data-testid="phenotypesValue">{data[0]?.items.length}</b>
          </div>
        )}
      </>
    </CardWrapper>
  );
};

OMIMCard.propTypes = {
  card: PropTypes.instanceOf(Card).isRequired,
  data: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.shape({
      version: PropTypes.string,
      items: PropTypes.arrayOf(
        PropTypes.shape({
          description: PropTypes.string,
          mutations: PropTypes.string,
          omim_id: PropTypes.number,
          phenotype_name: PropTypes.string,
          alternative_phenotype_names: PropTypes.arrayOf(PropTypes.string),
          references: PropTypes.arrayOf(
            PropTypes.shape({
              pub_med_references: PropTypes.arrayOf(PropTypes.number),
              reference_number: PropTypes.number,
              title: PropTypes.string,
              source: PropTypes.string,
              authors: PropTypes.string,
            })
          ),
        })
      ),
    }),
  ]),
};

OMIMCard.defaultProps = {
  data: {},
};

const mapStateToProps = (state) => ({
  data: getOMIMData(state),
});

export default connect(mapStateToProps)(OMIMCard);
